import { css } from '@emotion/react';
import styled from '@emotion/styled';

import {
  black,
  gray1,
  gray3,
  gray4,
  gray6,
  gray7,
  primary,
  white,
} from 'styles/global_defaults/colors';
import {
  boldFontWeight,
  semiBoldFontWeight,
  textLargeFontSize,
  textMediumFontSize,
  textSmallFontSize,
  textXSFontSize,
} from 'styles/global_defaults/fonts';
import {
  halfSpacing,
  standardSpacing,
  quarterSpacing,
  threeQuartersSpacing,
} from 'styles/global_defaults/scaffolding';

export const modalBodyStyles = css`
  display: flex;
  flex-direction: column;
  padding: 0px ${standardSpacing}px;

  .custom-modal-footer {
    display: flex;
    text-align: center;
    justify-content: center;
    padding: ${standardSpacing}px 0;
    gap: ${standardSpacing}px;
  }
`;

export const tooltipStyles = css`
  opacity: 1 !important;
  .arrow::before {
    border-bottom-color: ${white};
    border-top-color: ${white};
  }
  .bs4-tooltip-inner {
    background-color: ${white};
    max-width: fit-content;
    padding: ${threeQuartersSpacing}px;
    box-shadow: 0px 4px 10px 0px #0000001a;
    border-radius: ${quarterSpacing}px;
  }
  .help-resource-template {
    display: flex;
    flex-direction: column;
    align-items: center;
    .copy-example {
      display: flex;
      align-items: center;
      gap: ${halfSpacing}px;
      color: ${primary};
      font-size: ${textMediumFontSize}px;
      justify-content: center;
      margin-bottom: ${halfSpacing}px;
      background-color: transparent;
      border: none;
    }
  }
`;

export const CommonHeaderSection = styled.div<{ disabled?: boolean }>`
  background-color: ${(props) => (props.disabled ? gray7 : white)};
  padding: ${threeQuartersSpacing}px ${standardSpacing}px;

  .header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${halfSpacing}px;
    margin-bottom: ${standardSpacing}px;

    .active::before {
      color: #00ccbc;
    }

    .disabled::before {
      color: #d4dae1;
    }
    .warning::before {
      color: #fa6625;
    }

    .title {
      font-size: ${textLargeFontSize}px;
      font-weight: ${boldFontWeight};
      color: ${(props) => (props.disabled ? gray3 : black)};
    }
  }

  .alert-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${quarterSpacing}px;
    margin-bottom: ${standardSpacing}px;
    font-weight: ${semiBoldFontWeight};
    font-size: ${textSmallFontSize}px;
  }

  .description {
    margin-bottom: ${standardSpacing}px;
  }

  .switch-container {
    display: flex;
    align-items: center;
    gap: ${halfSpacing}px;
    padding: ${halfSpacing}px 0;

    .switch-disabled {
      .switch-container,
      .switch-content-container {
        background-color: ${gray6};
      }
    }

    .switch-label {
      font-size: 14px;
      cursor: pointer;
      color: ${gray1};
    }
    .switch-highlight {
      font-size: 14px;
      color: ${primary};
    }
  }
`;

export const aiLearningSection = (isDisabled: boolean) => css`
  background: ${isDisabled ? gray7 : white};
  padding-bottom: ${standardSpacing}px;
`;

export const teachingTeam = css`
  border: 1px solid ${gray4};
  margin-top: ${standardSpacing}px;
  margin: 0 ${standardSpacing}px;
  padding: ${threeQuartersSpacing}px;

  .recipients-tags {
    display: flex;
    justify-items: flex-start;
    flex-wrap: wrap;
    column-gap: 4px;
    row-gap: ${quarterSpacing}px;

    .recipient-input {
      border: none;
      background: transparent;
      min-width: 46px;
      max-width: 210px;
      outline: none;
      margin-right: ${halfSpacing}px;
    }
  }
`;

export const helpResourceForm = css`
  padding: 0 ${standardSpacing}px;
  display: flex;
  flex-direction: column;
  gap: ${standardSpacing}px;
  label {
    font-size: ${textMediumFontSize}px;
    padding-bottom: ${quarterSpacing}px;
    font-weight: ${semiBoldFontWeight};
  }
`;

// Help Resources Template Styles
export const helpResourcesTemplateStyles = css`
  background-color: #29a0d4;
  padding: ${halfSpacing}px;

  .section-items {
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${halfSpacing}px;
    gap: ${threeQuartersSpacing}px;
  }

  .help-container {
    background-color: ${white};
    padding: ${threeQuartersSpacing}px;
    border: 1px solid #e6e9ed;
    border-radius: ${quarterSpacing}px;
    color: black;
    text-align: left;
  }

  .need-help {
    font-size: ${textXSFontSize}px;
    color: ${gray3};
    font-weight: ${boldFontWeight};
  }

  .platform {
    margin-top: ${halfSpacing}px;
  }

  p {
    margin-bottom: 0;
  }

  a {
    font-weight: ${boldFontWeight};
    color: ${primary};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;
